export const loadCachedBlogById = (id) => {
  const cacheKey = id.replace("cache:", "");
  const cached = localStorage.getItem(cacheKey);

  if (!cached) {
    return { error: "not_found" };
  }

  try {
    const parsed = JSON.parse(cached);
    return {
      data: {
        ...parsed,
        updatedAt: new Date(parsed.updatedAt),
        images: parsed.photos,
        hasChanges: true,
        cacheKey: cacheKey,
      },
    };
  } catch (err) {
    return { error: "parse_error" };
  }
};

export const loadLatestCachedDraft = () => {
  const cachedKeys = Object.keys(localStorage).filter((key) =>
    key.startsWith("cachedDraft_")
  );

  if (cachedKeys.length === 0) return null;

  const latestKey = cachedKeys
    .map((key) => {
      try {
        const parsed = JSON.parse(localStorage.getItem(key));
        return {
          key,
          updatedAt: new Date(parsed.updatedAt).getTime(),
        };
      } catch (err) {
        return null;
      }
    })
    .filter(Boolean)
    .sort((a, b) => b.updatedAt - a.updatedAt)[0]?.key;

  if (!latestKey) return null;

  try {
    const cached = JSON.parse(localStorage.getItem(latestKey));
    return {
      ...cached,
      updatedAt: new Date(cached.updatedAt),
      hasChanges: true,
      cacheKey: latestKey,
    };
  } catch (err) {
    return null;
  }
};
